import { Dispatch, ReactElement, SetStateAction, Suspense } from 'react';
import dayjs from 'dayjs';
import { TYPE_DATE_PICKER } from 'utils/constants/sportsbook/results';
import { lazy } from 'utils/generic/lazy';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const { MobileCustomRangePicker } = lazy(
  () =>
    import(
      /* webpackChunkName: "mobile-custom-range-picker" */ './__partials/Mobile'
    )
);

const { DesktopCustomRangePicker } = lazy(
  () =>
    import(
      /* webpackChunkName: "desktop-custom-range-picker" */ './__partials/Desktop'
    )
);

type SessionPickerProps = {
  className?: string;
  fromDate: Date | dayjs.Dayjs;
  setStartDate: (date: dayjs.Dayjs) => void;
  toDate: Date | dayjs.Dayjs;
  setEndDate: (date: dayjs.Dayjs) => void;
  setPeriodValue?: Dispatch<SetStateAction<string>>;
  periodValue?: string;
  pickerValue: Date | dayjs.Dayjs;
  setPickerValue?: (date: dayjs.Dayjs) => void;
  setIsDatePicker?: (date: boolean) => void;
  period?: {
    value: number;
    unit: 'day' | 'month' | 'year';
  };
  bordered?: boolean;
  size?: 'large' | 'small' | undefined;
  modeDatePicker?: boolean;
  isDatePicker?: boolean;
  showTitles?: boolean;
  suffixIconSize?: number;
  loading?: boolean;
};

export const CustomRangePicker = (props: SessionPickerProps): ReactElement => {
  return (
    <Suspense
      fallback={
        !TYPE_DATE_PICKER ? (
          <Skeleton
            title={{
              style: { height: 22, margin: 0 }
            }}
            paragraph={false}
            active
          />
        ) : (
          <div className="dateFilterContainer__container">
            <Skeleton
              title={{
                style: {
                  width: 'calc(100% - 20px)',
                  height: 22,
                  margin: '8px 10px'
                }
              }}
              paragraph={false}
              active
            />
            <Skeleton
              title={{
                style: {
                  width: 'calc(100% - 20px)',
                  height: 22,
                  margin: '8px 10px'
                }
              }}
              paragraph={false}
              active
            />
          </div>
        )
      }
    >
      {props.modeDatePicker ? (
        <MobileCustomRangePicker {...props} />
      ) : (
        <DesktopCustomRangePicker {...props} />
      )}
    </Suspense>
  );
};
